import { render, staticRenderFns } from "./ClaimForms.vue?vue&type=template&id=75c61be8&scoped=true&lang=pug&"
import script from "./ClaimForms.vue?vue&type=script&lang=js&"
export * from "./ClaimForms.vue?vue&type=script&lang=js&"
import style0 from "./ClaimForms.vue?vue&type=style&index=0&id=75c61be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c61be8",
  null
  
)

export default component.exports